import './styles.css';
import React from 'react';
import moment from 'moment';
import Datetime from "react-datetime";
import { Modal } from 'react-bootstrap';
import Avatar from '../../../../../../images/face-0.jpg';
import FormSelector from '../../../../../../components/FormSelector';
import FormCreator from '../../../../../../components/FormCreator/FormCreator';


const ModalForm = ({ api, notifier, editState, editData, workData, handleFormData, modalState, onModalHide }) => {

    const momentTimeFormat = 'D-MM-YYYY';

    //DATA MODEL STATE
    const dataComponentsModel = {
        title: "",
        gender: "",
        birthDate: null,
        specialty: null
    };

    //STATES
    const [date, setDate] = React.useState(new Date());
    const [data, setData] = React.useState(dataComponentsModel);
    const [photo, setPhoto] = React.useState({ file: null, preview: '' });
    const [resume, setResume] = React.useState(null);

    React.useEffect(() => {
        editState && setDate(moment.utc(editData.birthDate));
        editState && setData({
            ...data,
            title: editData.title,
            gender: editData.gender,
            birthDate: editData.birthDate,
            specialty: editData.specialty?editData.specialty.id:null
        });
        editState && setPhoto({ ...photo, preview: editData.photo ? api.appFiles.getUrl(editData.photo.id) : Avatar });
    }, [editState, api, editData]);

    //FORM HANDLERS
    const mergeDataSubmit = formData => {
        const newData = { ...formData, ...data };
        //VALIDATIONS BEFORE SEND DATA
        if (!newData.name) {
            notifier.error('Olvidaste escribir el nombre');
            return;
        } else if (!newData.patLastName && !newData.matLastName) {
            notifier.error('Anota al menos un apellido');
            return;
        } else if (!newData.gender) {
            notifier.error('Olvidaste especificar el género');
            return;
        }
        else {
            editState
                ? handleFormData('edit', editData.id, newData, photo.file, resume)
                : handleFormData('create', null, newData, photo.file, resume);

        };
    };

    //DATES
    const handleFormDate = date => {
        setDate(date);
        setData({ ...data, birthDate: moment(date).format(momentTimeFormat) });
    };

    //FORM SELECTOR HANDLER
    const getSpecialty = value => {
        const [getValueId] = workData.filter(data => data.name === value).map(data => data.id);
        setData({ ...data, specialty: getValueId });
    };

    //UPLOAD FILES
    const getProfilePhoto = event => {
        const file = event.target.files[0];
        const fileURL = file ? URL.createObjectURL(file) : "";
        setPhoto({ ...photo, file: file, preview: fileURL });
    };

    const getAcademicResume = event => {
        const file = event.target.files[0];
        setResume(file);
    };


    const getGender = value => {
        let parseGender;

        if (value === "--") {
            parseGender = '';
        } else if (value === 'Femenino') {
            parseGender = 'F';
        } else {
            parseGender = 'M';
        };
        setData({ ...data, gender: parseGender });
    };

    // --- COMPONENT CONFIG ---
    //FORM CREATOR: Data model
    const dataModel = {
        name:
            editState
                ? editData.name
                : "",
        patLastName:
            editState
                ? editData.patLastName
                : "",
        matLastName:
            editState
                ? editData.matLastName
                : "",
        email:
            editState
                ? editData.email
                : "",
        fixedPhone:
            editState
                ? editData.fixedPhone
                : "",
        mobilePhone:
            editState
                ? editData.mobilePhone
                : "",
        professionalLicense:
            editState
                ? editData.professionalLicense
                : "",
        certificationNumber:
            editState
                ? editData.certificationNumber
                : "",
        rfc:
            editState
                ? editData.rfc
                : "",
        contactData:
            editState
                ? editData.contactData
                : "",
        residence:
            editState
                ? editData.residence
                : "",
        city:
            editState
                ? editData.city
                : ""
    };
    //FORM SELECTOR
    const doctorTitleOptions = [
        { value: "--" },
        { value: "Dr." },
        { value: "Dra." }
    ];
    const genderOptions = [
        { value: "--" },
        { value: "Femenino" },
        { value: "Masculino" }
    ];
    const specialtyOptions = workData.map(data => ({ value: data.name }));
    specialtyOptions.unshift({ value: '--' }); //Adding default value.

    //FORM CREATOR: Form model
    const formModel = [
        {
            title: "Nombre",
            tag: "input",
            type: "text",
            name: "name"
        },
        {
            title: "Apellido paterno:",
            tag: "input",
            type: "text",
            name: "patLastName"
        },
        {
            title: "Apellido materno:",
            tag: "input",
            type: "text",
            name: "matLastName"
        },
        {
            title: "Título",
            name: "title",
            component:
                <FormSelector
                    options={doctorTitleOptions}
                    defaultValue={editState ? editData.title : '--'}
                    handleFormSelector={value => setData({ ...data, title: value })}
                />
        },
        {
            title: "Género:",
            name: "gender",
            component:
                <FormSelector
                    options={genderOptions}
                    defaultValue={editState ? editData.gender === 'F' ? 'Femenino' : 'Masculino' : '--'}
                    handleFormSelector={getGender}
                />
        },
        {
            title: "Fecha de Nacimiento",
            name: "birthDate",
            component:
                <Datetime
                    utc
                    timeFormat={false}
                    value={date}
                    onChange={handleFormDate}
                />
        },
        {
            title: "Correo Electrónico:",
            tag: "input",
            type: "text",
            name: "email"
        },
        {
            title: 'Teléfono fijo:',
            tag: "input",
            type: "number",
            name: "fixedPhone"
        },
        {
            title: "Teléfono móvil:",
            tag: "input",
            type: "number",
            name: "mobilePhone"
        },
        {
            title: "Especialidad:",
            component:
                <FormSelector
                    options={specialtyOptions}
                    defaultValue={editState && editData.specialty? editData.specialty.name : '--'}
                    handleFormSelector={getSpecialty}
                />
        },
        {
            title: "Cédula profesional:",
            tag: "input",
            type: "text",
            name: "professionalLicense"
        },
        {
            title: "Número de certificado:",
            tag: "input",
            type: "number",
            name: "certificationNumber"
        },
        {
            title: "RFC:",
            tag: "input",
            type: "text",
            name: "rfc"
        },
        {
            title: "País:",
            name: "residence",
            tag: "input",
            type: "text",
        },
        {
            title: "Ciudad:",
            tag: "input",
            type: "text",
            name: "city"
        },
        {
            title: "Información pública de contacto:",
            tag: "textarea",
            name: "contactData"
        }
    ];
    return (
        <Modal
            show={modalState}
            onHide={() => onModalHide(false)}
        >
            <Modal.Header closeButton>
                <Modal.Title>{editState ? 'Actualizar usuario' : 'Añadir usuario'}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormCreator
                    formClassName='user-form'
                    editMode={editState}
                    dataModel={dataModel}
                    formModel={formModel}
                    handleFormData={mergeDataSubmit}
                >
                    {/* SECTION: UPLOAD FILES */}
                    <div>
                        <div>
                            <label>{editState ? 'Actualizar información académica:' : 'Información académica:'}</label>
                            <input type="file" onChange={getAcademicResume} />
                        </div>
                        <div>
                            <label>Foto de perfil:</label>
                            <img className="user-profile-photo" src={photo.preview ? photo.preview : Avatar} alt="Foto de perfil"
                            />
                            <input type="file" onChange={getProfilePhoto} />
                        </div>
                    </div>
                    <button type="submit">{editState ? 'Guardar cambios' : 'Crear usuario'}</button>
                </FormCreator>
            </Modal.Body>
        </Modal>
    );
};
export default ModalForm;


// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/PublicInGral/components/ModalForm/ModalForm.js